export default __webpack_public_path__ + "static/media/land-4.3c99686a.png";